export class Profil {
    static jsonMap = {
        id: { key: 'id', optional: true },
        idOrganisme: { key: 'idOrganisme', optional: true },
        idService: { key: 'idService' },
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    public id: number;
    public idOrganisme: number;
    public idService: number;
    public libelle: string;
}
